var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 16.6677H17.5015",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.751 2.91674C14.0825 2.58519 14.5322 2.39893 15.0011 2.39893C15.2332 2.39893 15.4631 2.44465 15.6776 2.5335C15.8921 2.62235 16.087 2.75257 16.2512 2.91674C16.4153 3.0809 16.5456 3.2758 16.6344 3.49029C16.7233 3.70478 16.769 3.93468 16.769 4.16684C16.769 4.39901 16.7233 4.6289 16.6344 4.8434C16.5456 5.05789 16.4153 5.25278 16.2512 5.41695L5.83362 15.8345L2.5 16.6679L3.3334 13.3343L13.751 2.91674Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilSvg);
export default __webpack_public_path__ + "static/media/editPencilSvg.73c2d1fa6484823a9b519db0f6867c1b.svg";
export { ForwardRef as ReactComponent };